(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  if (!customElements.get('production-notice')) {
    customElements.define('production-notice', class ProductionNotice extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-production-notice-dialog]');
        this.openButton = this.querySelector('[data-production-notice-open]');
        this.closeButton = this.querySelector('[data-production-notice-close]');
        this.openButton?.addEventListener('click', this.open);
        this.closeButton?.addEventListener('click', this.close);
        this.dialog?.addEventListener('click', this.handleBackdrop);
        this.dialog?.addEventListener('cancel', this.handleCancel);
        this.dialog?.addEventListener('close', this.restoreFocus);
        document.addEventListener('keydown', this.handleKeydown);
        this.resizeObserver = new ResizeObserver(this.syncHeight);
        this.resizeObserver.observe(this);
        this.syncHeight();
      }

      disconnectedCallback() {
        this.openButton?.removeEventListener('click', this.open);
        this.closeButton?.removeEventListener('click', this.close);
        this.dialog?.removeEventListener('click', this.handleBackdrop);
        this.dialog?.removeEventListener('cancel', this.handleCancel);
        this.dialog?.removeEventListener('close', this.restoreFocus);
        document.removeEventListener('keydown', this.handleKeydown);
        this.resizeObserver?.disconnect();
      }

      open = () => {
        if (!this.dialog) return;
        this.activeTrigger = document.activeElement;
        this.dialog.showModal();
        this.closeButton?.focus();
      };

      close = () => {
        this.dialog?.close();
      };

      handleBackdrop = (event) => {
        if (event.target === this.dialog) this.close();
      };

      handleCancel = (event) => {
        event.preventDefault();
        this.close();
      };

      handleKeydown = (event) => {
        if (event.key !== 'Escape' || !this.dialog?.open) return;
        event.preventDefault();
        this.close();
      };

      restoreFocus = () => {
        this.activeTrigger?.focus();
        this.activeTrigger = null;
      };

      syncHeight = () => {
        document.documentElement.style.setProperty('--production-notice-h', `${this.offsetHeight}px`);
        window.dispatchEvent(new CustomEvent('production-notice:resize'));
      };
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    'use strict';

    if (window.ChronosCartDrawerInitialized) return;
    window.ChronosCartDrawerInitialized = true;

    var section = document.querySelector('[data-cart-drawer-section]');
    if (!section) return;

    var dialog = section.querySelector('[data-cart-drawer-dialog]');
    var liveRegion = section.querySelector('[data-cart-live-region]');
    var activeTrigger = null;
    var pendingFocusRestore = false;
    var closeTimer = null;
    var feedbackTimer = null;
    var feedbackHideTimer = null;

    function getDynamicRoot() {
      return section.querySelector('[data-cart-drawer-dynamic]');
    }

    function getOpeners() {
      return Array.prototype.slice.call(document.querySelectorAll('[data-cart-drawer-open]'));
    }

    function isOpen() {
      return Boolean(dialog && dialog.open);
    }

    function currentSectionUrl() {
      return window.location.pathname + window.location.search;
    }

    function setBusy(isBusy) {
      var shell = section.querySelector('[data-cart-drawer-shell]');
      if (!shell) return;
      shell.setAttribute('data-cart-drawer-busy', isBusy ? 'true' : 'false');
    }

    function syncCount(count) {
      getOpeners().forEach(function (opener) {
        var badge = opener.querySelector('[data-cart-count]');
        if (!badge) return;
        badge.textContent = count;
        badge.hidden = count < 1;
      });
    }

    function fetchCartState() {
      return fetch(window.Shopify.routes.root + 'cart.js', {
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json'
        }
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart state request failed.');
        return response.json();
      }).then(function (cart) {
        if (typeof cart.item_count === 'number') {
          syncCount(cart.item_count);
        }
        return cart;
      });
    }

    function pulseCartIcon() {
      getOpeners().forEach(function (opener) {
        opener.classList.remove('is-cart-updated');
        void opener.offsetWidth;
        opener.classList.add('is-cart-updated');
        window.setTimeout(function () {
          opener.classList.remove('is-cart-updated');
        }, 620);
      });
    }

    function announce(message) {
      if (!liveRegion || !message) return;
      liveRegion.textContent = '';
      window.setTimeout(function () {
        liveRegion.textContent = message;
      }, 30);
    }

    function syncOpeners() {
      getOpeners().forEach(function (opener) {
        opener.setAttribute('aria-expanded', isOpen() ? 'true' : 'false');
      });
    }

    function focusDrawer() {
      var target = section.querySelector('[data-cart-drawer-close]') || section.querySelector('#CartDrawerTitle');
      if (target && typeof target.focus === 'function') {
        target.focus();
      }
    }

    function openDrawer(trigger) {
      if (!dialog) return;

      window.clearTimeout(closeTimer);
      if (isOpen()) {
        dialog.classList.remove('is-closing');
        window.requestAnimationFrame(function () {
          dialog.classList.add('is-open');
        });
        syncOpeners();
        return;
      }

      activeTrigger = trigger || document.activeElement;
      pendingFocusRestore = false;
      dialog.showModal();
      syncOpeners();
      window.requestAnimationFrame(function () {
        dialog.classList.remove('is-closing');
        dialog.classList.add('is-open');
      });
      window.setTimeout(focusDrawer, 60);
    }

    function closeDrawer(restoreFocus) {
      if (!dialog || !isOpen()) return;
      pendingFocusRestore = restoreFocus !== false;
      dialog.classList.remove('is-open');
      dialog.classList.add('is-closing');
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        if (dialog.open) {
          dialog.close();
        }
      }, 300);
    }

    function hideFeedback() {
      var feedback = section.querySelector('[data-cart-feedback]');
      if (!feedback) return;

      feedback.classList.remove('is-visible');
      window.clearTimeout(feedbackHideTimer);
      feedbackHideTimer = window.setTimeout(function () {
        feedback.hidden = true;
      }, 260);
    }

    function showFeedback(productTitle) {
      var feedback = section.querySelector('[data-cart-feedback]');
      if (!feedback) return;

      var title = feedback.querySelector('[data-cart-feedback-title]');
      if (title) {
        title.textContent = productTitle || '';
        title.hidden = !productTitle;
      }

      window.clearTimeout(feedbackTimer);
      window.clearTimeout(feedbackHideTimer);
      feedback.hidden = false;
      window.requestAnimationFrame(function () {
        feedback.classList.add('is-visible');
      });

      feedbackTimer = window.setTimeout(hideFeedback, 3600);
    }

    function setSubmitterState(submitter, state) {
      if (!submitter) return;

      var label = submitter.querySelector('span');
      if (!submitter.hasAttribute('data-cart-original-disabled')) {
        submitter.setAttribute('data-cart-original-disabled', submitter.disabled ? 'true' : 'false');
      }
      if (label && !submitter.hasAttribute('data-cart-original-label')) {
        submitter.setAttribute('data-cart-original-label', label.textContent);
      }
      window.clearTimeout(submitter._chronosCartFeedbackTimer);

      if (state === 'loading') {
        submitter.disabled = true;
        submitter.setAttribute('aria-busy', 'true');
        if (label) label.textContent = 'Dodawanie...';
        return;
      }

      if (state === 'success') {
        submitter.disabled = true;
        submitter.removeAttribute('aria-busy');
        submitter.classList.add('is-cart-added');
        if (label) label.textContent = 'Dodano do koszyka';
        submitter._chronosCartFeedbackTimer = window.setTimeout(function () {
          setSubmitterState(submitter, 'reset');
        }, 1700);
        return;
      }

      submitter.removeAttribute('aria-busy');
      submitter.classList.remove('is-cart-added');
      if (label && submitter.hasAttribute('data-cart-original-label')) {
        label.textContent = submitter.getAttribute('data-cart-original-label');
      }
      submitter.disabled = submitter.getAttribute('data-cart-original-disabled') === 'true';
      submitter.removeAttribute('data-cart-original-disabled');
      submitter.removeAttribute('data-cart-original-label');
    }

    function applyRenderedSection(html) {
      if (!html) return;

      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var incomingDynamic = doc.querySelector('[data-cart-drawer-dynamic]');
      var currentDynamic = getDynamicRoot();

      if (incomingDynamic && currentDynamic) {
        currentDynamic.innerHTML = incomingDynamic.innerHTML;
      }
    }

    function fetchDrawerSection() {
      return fetch(window.Shopify.routes.root + '?section_id=cart-drawer', {
        credentials: 'same-origin',
        headers: {
          'Accept': 'text/html'
        }
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart drawer section request failed.');
        return response.text();
      });
    }

    function refreshFromPayload(payload, liveMessage) {
      var nextCount = typeof payload.item_count === 'number' ? payload.item_count : null;
      var renderedSection = payload.sections && payload.sections['cart-drawer'] ? payload.sections['cart-drawer'] : null;

      if (renderedSection) {
        applyRenderedSection(renderedSection);
        var renderedCountSync = nextCount !== null ? (syncCount(nextCount), Promise.resolve()) : fetchCartState();
        return renderedCountSync.then(function () {
          if (liveMessage) announce(liveMessage);
        });
      }

      return fetchDrawerSection().then(function (html) {
        applyRenderedSection(html);
        var fallbackCountSync = nextCount !== null ? (syncCount(nextCount), Promise.resolve()) : fetchCartState();
        return fallbackCountSync.then(function () {
          if (liveMessage) announce(liveMessage);
        });
      });
    }

    function cartRequest(url, payload, options) {
      options = options || {};

      return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            var error = new Error('Cart request failed.');
            error.data = data;
            throw error;
          }

          return data;
        });
      }).then(function (data) {
        return refreshFromPayload(data, options.liveMessage);
      });
    }

    function changeLine(lineKey, quantity) {
      return cartRequest(window.Shopify.routes.root + 'cart/change.js', {
        id: lineKey,
        quantity: quantity,
        sections: 'cart-drawer',
        sections_url: currentSectionUrl()
      }, {
        liveMessage: quantity > 0 ? 'Koszyk zaktualizowany.' : 'Produkt usunięty z koszyka.'
      });
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-cart-drawer-open]');
      if (opener) {
        event.preventDefault();
        openDrawer(opener);
        return;
      }

      var feedbackOpener = event.target.closest('[data-cart-feedback-open]');
      if (feedbackOpener) {
        event.preventDefault();
        hideFeedback();
        openDrawer(feedbackOpener);
        return;
      }

      var closer = event.target.closest('[data-cart-drawer-close]');
      if (closer) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      var quantityButton = event.target.closest('[data-cart-quantity-change]');
      if (quantityButton) {
        event.preventDefault();
        var quantityDelta = parseInt(quantityButton.getAttribute('data-cart-quantity-change'), 10);
        var lineKey = quantityButton.getAttribute('data-line-key');
        var line = quantityButton.closest('[data-cart-line]');
        var currentQuantity = line ? parseInt(line.getAttribute('data-line-quantity'), 10) : 0;
        var nextQuantity = Math.max(0, currentQuantity + quantityDelta);

        setBusy(true);
        changeLine(lineKey, nextQuantity).catch(function () {
          announce('Nie udało się zaktualizować koszyka.');
        }).finally(function () {
          setBusy(false);
        });
        return;
      }

      var removeButton = event.target.closest('[data-cart-remove]');
      if (removeButton) {
        event.preventDefault();
        var removeLineKey = removeButton.getAttribute('data-line-key');

        setBusy(true);
        changeLine(removeLineKey, 0).catch(function () {
          announce('Nie udało się zaktualizować koszyka.');
        }).finally(function () {
          setBusy(false);
        });
      }
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.matches('form[action*="/cart/add"]')) return;
      if (event.defaultPrevented) return;

      event.preventDefault();

      var submitter = event.submitter;
      var formData = new FormData(form);
      var fallbackTitle = '';
      formData.append('sections', 'cart-drawer');
      formData.append('sections_url', currentSectionUrl());

      if (form.closest('[data-product-title]')) {
        fallbackTitle = form.closest('[data-product-title]').getAttribute('data-product-title') || '';
      }

      setSubmitterState(submitter, 'loading');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json'
        },
        body: formData
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            var error = new Error('Add to cart failed.');
            error.data = data;
            throw error;
          }

          return data;
        });
      }).then(function (data) {
        var productTitle = data.product_title || data.title || fallbackTitle;
        return refreshFromPayload(data, 'Produkt dodany do koszyka.').catch(function () {
          return fetchCartState().catch(function () {});
        }).then(function () {
          setSubmitterState(submitter, 'success');
          pulseCartIcon();
          showFeedback(productTitle);
        });
      }).catch(function () {
        setSubmitterState(submitter, 'reset');
        HTMLFormElement.prototype.submit.call(form);
      });
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        closeDrawer();
      }
    });

    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeDrawer();
    });

    dialog.addEventListener('close', function () {
      window.clearTimeout(closeTimer);
      dialog.classList.remove('is-open', 'is-closing');
      syncOpeners();
      if (pendingFocusRestore && activeTrigger && typeof activeTrigger.focus === 'function') {
        activeTrigger.focus();
      }
      pendingFocusRestore = false;
    });

    var initialCount = parseInt(section.getAttribute('data-cart-initial-count'), 10);
    if (!Number.isNaN(initialCount)) {
      syncCount(initialCount);
    }
    syncOpeners();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-garden-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.contact-garden').forEach(function (sectionRoot) {
      var items = sectionRoot.querySelectorAll('[data-garden-reveal]');
      if (!items.length) return;

      if (!('IntersectionObserver' in window)) {
        items.forEach(function (item) {
          item.classList.add('is-visible');
        });
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.2 });

      items.forEach(function (item) {
        observer.observe(item);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-map"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.contact-map [data-map-reveal]').forEach(function (reveal) {
      if (!('IntersectionObserver' in window)) {
        reveal.classList.add('is-visible');
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.15 });

      observer.observe(reveal);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-split"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var searchParams = new URLSearchParams(window.location.search);
    var subjectParam = searchParams.get('temat') || searchParams.get('subject');

    function normalizeValue(value) {
      return (value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    document.querySelectorAll('.contact-split').forEach(function (sectionRoot) {
      var reveals = sectionRoot.querySelectorAll('[data-contact-reveal]');

      if (!('IntersectionObserver' in window)) {
        reveals.forEach(function (item) {
          item.classList.add('is-visible');
        });
      } else if (reveals.length) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.2 });

        reveals.forEach(function (item) {
          observer.observe(item);
        });
      }

      var select = sectionRoot.querySelector('[data-subject-select]');
      if (subjectParam && select) {
        var normalizedSubject = normalizeValue(subjectParam);
        Array.prototype.slice.call(select.options).forEach(function (option) {
          if (normalizeValue(option.value) === normalizedSubject) {
            select.value = option.value;
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-gallery-scroll"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.cs-gallery-scroll');

    sections.forEach((section) => {
      const track = section.querySelector('[data-gallery-track]');
      const prev = section.querySelector('[data-gallery-prev]');
      const next = section.querySelector('[data-gallery-next]');
      const progress = section.querySelector('[data-gallery-progress]');

      if (!track || !progress) return;

      let isPointerDown = false;
      let startX = 0;
      let startScroll = 0;

      const updateProgress = () => {
        const scrollable = track.scrollWidth - track.clientWidth;

        if (scrollable <= 0) {
          progress.style.width = '100%';
          progress.style.transform = 'translateX(0)';
          if (prev) prev.disabled = true;
          if (next) next.disabled = true;
          return;
        }

        const visibleRatio = Math.max(track.clientWidth / track.scrollWidth, 0.15);
        const current = Math.min(Math.max(track.scrollLeft / scrollable, 0), 1);
        const travelPercent = ((1 - visibleRatio) / visibleRatio) * 100;

        progress.style.width = `${visibleRatio * 100}%`;
        progress.style.transform = `translateX(${current * travelPercent}%)`;

        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= scrollable - 2;
      };

      const scrollByViewport = (direction) => {
        const amount = Math.max(track.clientWidth * 0.82, 320) * direction;
        track.scrollBy({ left: amount, behavior: 'smooth' });
      };

      if (prev) {
        prev.addEventListener('click', () => scrollByViewport(-1));
      }

      if (next) {
        next.addEventListener('click', () => scrollByViewport(1));
      }

      track.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);

      track.addEventListener('pointerdown', (event) => {
        isPointerDown = true;
        startX = event.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });

      track.addEventListener('pointermove', (event) => {
        if (!isPointerDown) return;
        const delta = event.clientX - startX;
        track.scrollLeft = startScroll - delta;
      });

      const stopDrag = (event) => {
        if (!isPointerDown) return;
        isPointerDown = false;
        track.classList.remove('is-dragging');
        if (event) {
          track.releasePointerCapture(event.pointerId);
        }
      };

      track.addEventListener('pointerup', stopDrag);
      track.addEventListener('pointercancel', stopDrag);
      track.addEventListener('pointerleave', stopDrag);

      updateProgress();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-shop-the-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.cs-shop-section');

    sections.forEach((section) => {
      if (section.dataset.shopCarouselReady === 'true') return;
      section.dataset.shopCarouselReady = 'true';

      const viewport = section.querySelector('[data-shop-viewport]');
      const rail = section.querySelector('[data-shop-rail]');
      const prev = section.querySelector('[data-shop-prev]');
      const next = section.querySelector('[data-shop-next]');

      if (!viewport || !rail || !prev || !next) return;

      const desktopQuery = window.matchMedia('(max-width: 989px)');
      const itemCount = rail.children.length;

      const canUseCarousel = () => {
        const desktopCarousel = viewport.classList.contains('is-desktop-carousel');
        const mobile = desktopQuery.matches;
        return itemCount > 1 && (desktopCarousel || mobile);
      };

      const updateButtons = () => {
        const enableArrows = canUseCarousel();
        prev.style.display = enableArrows ? 'inline-flex' : 'none';
        next.style.display = enableArrows ? 'inline-flex' : 'none';

        if (!enableArrows) {
          prev.disabled = true;
          next.disabled = true;
          return;
        }

        const scrollable = rail.scrollWidth - rail.clientWidth;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= scrollable - 2;
      };

      const scrollByAmount = (direction) => {
        const firstItem = rail.querySelector('.cs-shop__item');
        const gap = parseFloat(getComputedStyle(rail).columnGap) || parseFloat(getComputedStyle(rail).gap) || 0;
        const itemWidth = firstItem ? firstItem.getBoundingClientRect().width + gap : Math.max(rail.clientWidth * 0.82, 260);
        const amount = itemWidth * direction;
        rail.scrollBy({ left: amount, behavior: 'smooth' });
      };

      prev.addEventListener('click', () => scrollByAmount(-1));
      next.addEventListener('click', () => scrollByAmount(1));
      rail.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);

      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-category"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function openHashTarget() {
      if (!window.location.hash) return;

      var id = decodeURIComponent(window.location.hash.slice(1));
      if (!id) return;

      var target = document.getElementById(id);
      if (!target) return;

      if (target.tagName && target.tagName.toLowerCase() === 'details') {
        target.open = true;
      }

      var parentDetails = target.closest ? target.closest('details') : null;
      if (parentDetails) {
        parentDetails.open = true;
      }

      window.requestAnimationFrame(function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openHashTarget);
    } else {
      openHashTarget();
    }

    window.addEventListener('hashchange', openHashTarget);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-category-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function updateRail(rail, scrollArea) {
      var maxScroll = scrollArea.scrollWidth - scrollArea.clientWidth;
      var isScrollable = maxScroll > 4;
      rail.classList.toggle('is-scrollable', isScrollable);

      if (!isScrollable) {
        rail.style.setProperty('--home-cat-progress-width', '18%');
        return;
      }

      var progress = Math.min(scrollArea.scrollLeft / maxScroll, 1);
      rail.style.setProperty('--home-cat-progress-width', (18 + progress * 82).toFixed(1) + '%');
    }

    document.querySelectorAll('[data-home-cat-rail]').forEach(function (rail) {
      var scrollArea = rail.querySelector('[data-home-cat-scroll]');
      if (!scrollArea) return;

      var rafId = null;
      var requestUpdate = function () {
        if (rafId) return;
        rafId = window.requestAnimationFrame(function () {
          rafId = null;
          updateRail(rail, scrollArea);
        });
      };

      updateRail(rail, scrollArea);
      scrollArea.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var scrollButton = document.querySelector('.home-hero__scroll-button');
  var target = document.getElementById('HomeCategories');
  if (!scrollButton || !target) return;

  scrollButton.addEventListener('click', function (event) {
    event.preventDefault();

    var headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-h')) || 0;
    var targetTop = target.getBoundingClientRect().top + window.scrollY - headerHeight - 16;

    window.scrollTo({
      top: Math.max(targetTop, 0),
      behavior: 'smooth'
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-header"]) return;
  try {
    
(function () {
  'use strict';
  var header = document.querySelector('.site-header');
  var toggle  = document.querySelector('.site-header__toggle');
  var drawer  = document.getElementById('site-nav-drawer');
  if (!header || !toggle || !drawer) return;

  var backdrop = drawer.querySelector('.site-nav-drawer__backdrop');
  var closeBtn = drawer.querySelector('.site-nav-drawer__close');
  var panel    = drawer.querySelector('.site-nav-drawer__panel');
  var closeButtons = drawer.querySelectorAll('[data-drawer-close]');
  var panelTriggers = drawer.querySelectorAll('[data-drawer-target]');
  var backButtons = drawer.querySelectorAll('[data-drawer-back]');
  var drawerPanels = drawer.querySelectorAll('[data-drawer-panel]');
  var searchOverlay = document.getElementById('site-search-overlay');
  var searchOpeners = document.querySelectorAll('[data-search-open]');
  var searchClosers = searchOverlay ? searchOverlay.querySelectorAll('[data-search-close]') : [];
  var searchPanel = searchOverlay ? searchOverlay.querySelector('.site-search-overlay__panel') : null;
  var searchInput = searchOverlay ? searchOverlay.querySelector('.site-search-overlay__input') : null;
  var searchForm = searchOverlay ? searchOverlay.querySelector('.site-search-overlay__form') : null;
  var activeSearchTrigger = null;
  var activePanelStack = [];
  var menuCloseTimer = null;

  function syncHeaderState() {
    var notice = document.querySelector('[data-production-notice]');
    var headerHeight = header.offsetHeight + (notice ? notice.offsetHeight : 0);
    document.documentElement.style.setProperty('--header-h', headerHeight + 'px');

    if (header.classList.contains('site-header--hero')) {
      header.classList.toggle('site-header--scrolled', window.scrollY > 12);
    }
  }

  function getFocusable(container) {
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (element) {
      return element.offsetParent !== null;
    });
  }

  function isSearchOpen() {
    return searchOverlay && searchOverlay.classList.contains('is-open');
  }

  function openSearch(trigger) {
    if (!searchOverlay || !searchPanel) return;

    activeSearchTrigger = trigger || document.activeElement;

    if (drawer.classList.contains('is-open')) {
      close(false);
    }

    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    window.setTimeout(function () {
      if (searchInput) {
        searchInput.focus();
        searchInput.select();
      } else {
        searchPanel.focus();
      }
    }, 30);
  }

  function closeSearch() {
    if (!searchOverlay) return;

    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    if (activeSearchTrigger && typeof activeSearchTrigger.focus === 'function') {
      activeSearchTrigger.focus();
    }

    activeSearchTrigger = null;
  }

  document.querySelectorAll('.site-header__menu-item--has-children').forEach(function (menuItem) {
    function openMenu() {
      window.clearTimeout(menuCloseTimer);
      document.querySelectorAll('.site-header__menu-item--has-children.is-open').forEach(function (openItem) {
        if (openItem !== menuItem) openItem.classList.remove('is-open');
      });
      menuItem.classList.add('is-open');
    }

    function closeMenu() {
      window.clearTimeout(menuCloseTimer);
      menuCloseTimer = window.setTimeout(function () {
        menuItem.classList.remove('is-open');
      }, 120);
    }

    menuItem.addEventListener('pointerenter', openMenu);
    menuItem.addEventListener('pointerleave', closeMenu);
    menuItem.addEventListener('focusin', openMenu);
    menuItem.addEventListener('focusout', function (event) {
      if (!menuItem.contains(event.relatedTarget)) {
        closeMenu();
      }
    });
  });

  document.querySelectorAll('.site-header__mega').forEach(function (mega) {
    var childItems = mega.querySelectorAll('[data-menu-child]');
    var grandPanels = mega.querySelectorAll('[data-menu-panel]');

    function activatePanel(index) {
      childItems.forEach(function (item) {
        item.classList.toggle('site-header__mega-child--active', item.dataset.menuChild === index);
      });

      grandPanels.forEach(function (grandPanel) {
        grandPanel.classList.toggle('site-header__grand-list--active', grandPanel.dataset.menuPanel === index);
      });
    }

    childItems.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        activatePanel(item.dataset.menuChild);
      });

      item.addEventListener('focusin', function () {
        activatePanel(item.dataset.menuChild);
      });
    });
  });

  function resetPanels() {
    activePanelStack = [];
    drawerPanels.forEach(function (drawerPanel) {
      drawerPanel.classList.remove('is-active');
      drawerPanel.setAttribute('aria-hidden', 'true');
    });

    if (panelTriggers.length) {
      panelTriggers.forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });
    }
  }

  function open() {
    toggle.setAttribute('aria-expanded', 'true');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (panel) panel.focus();
  }

  function close(restoreFocus) {
    toggle.setAttribute('aria-expanded', 'false');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    resetPanels();
    if (restoreFocus !== false) {
      toggle.focus();
    }
  }

  function openPanel(panelId) {
    var targetPanel = document.getElementById(panelId);
    if (!targetPanel) return;

    activePanelStack.push(targetPanel);
    var trigger = drawer.querySelector('[data-drawer-target="' + panelId + '"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    targetPanel.classList.add('is-active');
    targetPanel.setAttribute('aria-hidden', 'false');

    var firstControl = targetPanel.querySelector('button, a');
    if (firstControl) firstControl.focus();
  }

  function goBack() {
    var currentPanel = activePanelStack.pop();
    if (!currentPanel) return;

    currentPanel.classList.remove('is-active');
    currentPanel.setAttribute('aria-hidden', 'true');

    var trigger = drawer.querySelector('[data-drawer-target="' + currentPanel.id + '"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    var previousPanel = activePanelStack[activePanelStack.length - 1];
    if (previousPanel) {
      var previousControl = previousPanel.querySelector('button, a');
      if (previousControl) previousControl.focus();
    } else {
      var rootControl = drawer.querySelector('[data-drawer-target]');
      if (rootControl) rootControl.focus();
    }
  }

  toggle.addEventListener('click', function () {
    drawer.classList.contains('is-open') ? close() : open();
  });

  searchOpeners.forEach(function (opener) {
    opener.addEventListener('click', function (event) {
      event.preventDefault();
      openSearch(opener);
    });
  });

  searchClosers.forEach(function (button) {
    button.addEventListener('click', closeSearch);
  });

  if (searchForm) {
    searchForm.addEventListener('submit', function (event) {
      if (!searchInput || searchInput.value.trim() !== '') return;
      event.preventDefault();
      searchInput.focus();
    });
  }

  if (backdrop) backdrop.addEventListener('click', close);
  if (closeBtn) closeBtn.addEventListener('click', close);

  closeButtons.forEach(function (button) {
    button.addEventListener('click', close);
  });

  panelTriggers.forEach(function (button) {
    button.setAttribute('aria-expanded', 'false');
    button.addEventListener('click', function () {
      openPanel(button.dataset.drawerTarget);
    });
  });

  backButtons.forEach(function (button) {
    button.addEventListener('click', goBack);
  });

  document.addEventListener('keydown', function (e) {
    if (isSearchOpen()) {
      if (e.key === 'Escape') {
        closeSearch();
        return;
      }

      if (e.key === 'Tab' && searchPanel) {
        var focusable = getFocusable(searchPanel);
        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (!first || !last) return;

        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      if (activePanelStack.length) {
        goBack();
      } else {
        close();
      }
    }
  });

  syncHeaderState();
  window.addEventListener('scroll', syncHeaderState, { passive: true });
  window.addEventListener('resize', syncHeaderState);
  window.addEventListener('production-notice:resize', syncHeaderState);
})();

  } catch(e) { console.error(e); }
})();
})();
